export default __webpack_public_path__ + "static/body-v2-10-belt-015f1749f0b2188510c0f07907ba32a7.png";